module.exports = __webpack_public_path__ + "img/miguel-sanchez.e04c90c0.jpg";